import { MenuItems } from '@ui/header/constants';
import { nanoid } from 'nanoid';
import Link from 'next/link';

export default function MenuOtions() {
    return (
        <div className={`grid grid-cols-3 sm:grid-cols-4 md:grid-cols-8 gap-4 bg-[#3232C2] p-2 py-6 rounded-lg text-white`}>
            {MenuItems.map((item) => {
                return (
                    <Link href={item.link} key={nanoid(5)} className={`flex flex-col gap-2 items-center justify-between`}>
                        {item.icon}
                        <span className={`whitespace-nowrap text-sm`}>{item.label}</span>
                    </Link>
                );
            })}
        </div>
    )
}